export enum LinkAudienceKind {
	Anonymous = 1,
	Organization = 2,
	SpecificPeople = 3,
	PeopleWithExistingAccess = 4
}

export enum LinkPermission {
	CanView = "CanView",
	CanEdit = "CanEdit"
}
